/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./synthetic-performance-tracking.component";
import * as i2 from "@laurentgoudet/ngx-cookie";
var styles_SyntheticPerformanceTrackingComponent = [];
var RenderType_SyntheticPerformanceTrackingComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_SyntheticPerformanceTrackingComponent, data: {} });
export { RenderType_SyntheticPerformanceTrackingComponent as RenderType_SyntheticPerformanceTrackingComponent };
export function View_SyntheticPerformanceTrackingComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, null, null, null, null, null, null, null))], null, null); }
export function View_SyntheticPerformanceTrackingComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fl-synthetic-performance-tracking", [], null, null, null, View_SyntheticPerformanceTrackingComponent_0, RenderType_SyntheticPerformanceTrackingComponent)), i0.ɵdid(1, 114688, null, 0, i1.SyntheticPerformanceTrackingComponent, [i2.CookieService, i0.Renderer2], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SyntheticPerformanceTrackingComponentNgFactory = i0.ɵccf("fl-synthetic-performance-tracking", i1.SyntheticPerformanceTrackingComponent, View_SyntheticPerformanceTrackingComponent_Host_0, {}, {}, []);
export { SyntheticPerformanceTrackingComponentNgFactory as SyntheticPerformanceTrackingComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/@shared/tracking/synthetic-performance-tracking.component.ngfactory.js.pre-build-optimizer.js